import { PostDadosPessoaisRequest } from '@services/postDadosPessoaisService'

interface BankDataSource {
  bancoSelecionado?: string | number
  tipoContaSelecionado?: string | number
  agencia?: string
  contaDadosBancarios?: string
  digito?: string
}

export const INVALID_MODALITY_ACCOUNT_SUBTITLE =
  'Não é possível usar a conta cadastrada. Cadastre outra conta para receber o empréstimo.'

export const toBankData = ({
  bancoSelecionado,
  tipoContaSelecionado,
  agencia,
  contaDadosBancarios,
  digito,
}: BankDataSource): PostDadosPessoaisRequest['bankData'] => ({
  bankCode: String(bancoSelecionado ?? ''),
  accountType: String(tipoContaSelecionado ?? ''),
  bankBranch: String(agencia ?? ''),
  accountNumber: String(contaDadosBancarios ?? ''),
  accountDigit: String(digito ?? ''),
})
